import {
  REMOVE_QUIZZ_ANSWER,
  REMOVE_QUIZZ_ANSWER_SUCCESS,
  REMOVE_QUIZZ_ANSWER_CLEAN,
  REMOVE_QUIZZ_ANSWER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  answer: undefined,
}

const QuizzAnswerRemove = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_QUIZZ_ANSWER:
      state = {
        ...state,
        loading: true,
      }
      break
    case REMOVE_QUIZZ_ANSWER_SUCCESS:
      state = {
        ...state,
        answer: action.payload.answer,
        loading: false,
        done: true,
      }
      break
    case REMOVE_QUIZZ_ANSWER_CLEAN:
      state = initialState
      break
    case REMOVE_QUIZZ_ANSWER_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        done: false,
        answer: undefined,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default QuizzAnswerRemove
